import React from "react"

import { AiOutlineShareAlt } from "../../../../AppReactIcons"
import makeDate from "../../../../utils/makeDate"
import getBookmarkIcon from "../utils/getBookmarkIcon"

interface iMetaData {
  last_updated_at?: string
  onClickBookmark?: () => void
  bookmarked?: boolean | null
  read_time?: string
  onClickShare?: () => void
  onClickDiscussion: () => void
}

const MetaDataButton: React.FC<{
  marginRight: boolean
  Icon: any
  onClick?: () => void
}> = ({ marginRight, Icon, onClick }) => (
  <button
    className={`${marginRight && "mr-4"} text-gray-600 hover:text-gray-700`}
    onClick={onClick}
  >
    {Icon}
  </button>
)

const MetaData: React.FC<iMetaData> = ({
  last_updated_at,
  onClickBookmark,
  bookmarked,
  read_time,
  onClickShare,
  onClickDiscussion,
}) => {
  return (
    <div className="block sm:flex mt-3 item-center justify-between xl:hidden">
      <div className="flex sm:hidden items-center mb-3 sm:mt-0  text-lg">
        <MetaDataButton
          marginRight={true}
          Icon={getBookmarkIcon(bookmarked === undefined ? false : bookmarked)}
          onClick={onClickBookmark}
        />
        {/*
          * <MetaDataButton
          marginRight={true}
          Icon={<FaRegComment />}
          onClick={onClickDiscussion}
        />*/}
        <MetaDataButton
          marginRight={false}
          Icon={<AiOutlineShareAlt />}
          onClick={onClickShare}
        />
      </div>

      <p className=" text-sm text-gray-600">
        {last_updated_at && (
          <>
            <span>{makeDate(last_updated_at)}</span>
            <span>&nbsp;&middot;&nbsp;</span>
          </>
        )}
        {read_time && <span>{read_time} read</span>}
      </p>

      <div className="hidden sm:flex items-center mt-3 sm:mt-0">
        <MetaDataButton
          marginRight={true}
          Icon={getBookmarkIcon(bookmarked === undefined ? false : bookmarked)}
          onClick={onClickBookmark}
        />
        {/*<MetaDataButton
          marginRight={true}
          Icon={<FaRegComment />}
          onClick={onClickDiscussion}
        />*/}
        <MetaDataButton
          marginRight={false}
          Icon={<AiOutlineShareAlt />}
          onClick={onClickShare}
        />
      </div>
    </div>
  )
}

export default MetaData
